import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import Delivery from "./api/delivery";
import Store from "./api/store";

import instance from "./main";
import { changeFavicon } from "@/utils";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      paths: [
        "guid",
        "userInfo",
        "tokenContent",
        "storeId",
        "zipCode",
        "isLogin"
      ]
    }),
    createPersistedState({
      paths: [
        "deliveryMenu",
        "categoryKeys",
        "deliveries",
        "categories",
        "carts",
        "showCookie",
        "storeInfo",
        "recommendDeliveries",
        "deliveryType",
        "languageList",
        "languageListAll"
      ],
      storage: window.sessionStorage
    })
  ],
  state: {
    isLogin: false,
    storeId:
      process.env.NODE_ENV === "development"
        ? "b21dd4fe4b484a76a0108ffa4d7bfb4f"
        : undefined,
    showCookie: true,
    // 用户 id
    guid: null,
    tokenContent: null,
    userInfo: null,
    categories: {},
    categoryKeys: [],
    deliveries: {},
    deliveryMenu: [],
    currentDelivery: null,
    carts: [],
    storePayment: [],
    addressList: [],
    storeDeliveryArea: [],
    storeInfo: {
      address: {},
      logo: {}
    },
    recommendDeliveries: [],
    languages: [
      {
        title: "简体中文",
        value: "zh-CN"
      },
      {
        title: "Español",
        value: "es-ES"
      }
    ],
    language: localStorage.getItem("language") || "es-ES",
    discounts: [],
    zipCode: null,
    keyword: false,
    zipCodeypeType: false,
    deliveryFee: 0,

    // 移动端选中的菜品分类
    activeCategoryPhone: null,

    payAction:
      process.env.NODE_ENV === "development"
        ? "https://sis-t.redsys.es:25443/sis/realizarPago"
        : "https://sis.redsys.es/sis/realizarPago",

    deliveryType: null, // 0 配送到家，1 上门自取
    languageList: [], //启用的语言列表
    languageListAll: [], //包含未启用的语言列表
    languageListVal: [
      "es-ES",
      "italian",
      "portuguese",
      "english",
      "french",
      "german",
      "zh-CN"
    ]
  },
  getters: {
    getLanguageIndex(state) {
      let language = state.language;
      let languageListVal = state.languageListVal;
      return languageListVal.findIndex(item => item === language) || 0;
    },
    getTranslateIndex(state) {
      let language = state.language;
      let languageListVal = state.languageListVal;
      let val = languageListVal.findIndex(item => item === language) || 0;
      return (
        (state.languageListAll || []).findIndex(
          item => item.enable && item.val === val + 1
        ) || 0
      );
    },
    categoryList(state) {
      return state.categoryKeys.map((item, index) => {
        return {
          ...state.categories[item],
          guid: state.categories[item].guid + index
        };
      });
    },
    currentDelivery(state) {
      return state.deliveries[state.currentDelivery] || {};
    },
    cart(state) {
      let subtotal = 0;
      const items = state.carts.map(item => {
        const delivery = { ...state.deliveries[item.guid] };

        if (item.attributes && item.attributes.length != 0) {
          delivery.attributes_cate.forEach((cate, cateIndex) => {
            if (cate.attributes) {
              cate.attributes.forEach((item2, index) => {
                delivery.attributes_cate[cateIndex].attributes[
                  index
                ].check = false;
                if (item.attributes.includes(item2.guid)) {
                  delivery.attributes_cate[cateIndex].attributes[
                    index
                  ].check = true;
                }
              });
            }
          });
        }

        subtotal += item.num * parseFloat(delivery.price);

        return {
          ...item,
          delivery
        };
      });

      return {
        items,
        subtotal
      };
    },

    payStatusList() {
      return {
        "0": instance.$t("pay_status.un_paid"),
        "1": instance.$t("pay_status.partial"),
        "2": instance.$t("pay_status.paid"),
        "3": instance.$t("pay_status.partial_refund"),
        "4": instance.$t("pay_status.refund")
      };
    },

    orderStatusList() {
      return {
        "0": instance.$t("order_status.wait"),
        "1": instance.$t("order_status.packet"),
        "2": instance.$t("order_status.on_the_way"),
        "3": instance.$t("order_status.arrived"),
        "4": instance.$t("order_status.completed"),
        "5": instance.$t("order_status.settled"),
        "6": instance.$t("order_status.refund")
      };
    },
    appointmentOrderStatusList() {
      return {
        "1": instance.$t("home.reserva.reserva_status1"),
        "2": instance.$t("home.reserva.reserva_status2"),
        "3": instance.$t("home.reserva.reserva_status3"),
        "4": instance.$t("home.reserva.reserva_status4"),
        "5": instance.$t("home.reserva.reserva_status5")
      };
    }
  },
  mutations: {
    login(state) {
      state.isLogin = true;
    },
    logout(state) {
      state.isLogin = false;
      state.guid = null;
      state.tokenContent = null;
      state.userInfo = null;
    },
    setGuid(state, guid) {
      state.guid = guid;
    },
    setZipCode(state, zipCode) {
      state.zipCode = zipCode;
      console.log("查看缓存zipCode", zipCode);
    },
    setKeyword(state, keyword) {
      state.keyword = keyword;
    },
    setStoreId(state, storeId) {
      console.log("setStoreId", new Date().getTime(), storeId);
      state.storeId = storeId;
    },
    setTokenContent(state, token) {
      state.tokenContent = token;
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    setDeliveryFee(state, deliveryFee) {
      state.deliveryFee = deliveryFee;
    },
    setCategories(state, categories) {
      state.categories = JSON.parse(JSON.stringify(categories));
    },
    setCategoryKeys(state, categoryKeys) {
      state.categoryKeys = JSON.parse(JSON.stringify(categoryKeys));
    },
    setDeliveries(state, deliveries) {
      state.deliveries = JSON.parse(JSON.stringify(deliveries));
    },
    setCurrentDelivery(state, guid) {
      state.currentDelivery = guid;
    },
    setDelivery(state, delivery) {
      state.deliveries[delivery.guid] = {
        ...delivery
      };
    },
    setDeliveryMenu(state, menu) {
      state.deliveryMenu = JSON.parse(JSON.stringify(menu));
    },
    setStoreDeliveryArea(state, data) {
      state.storeDeliveryArea = data;
    },
    setZipCodeypeType(state, data) {
      state.zipCodeypeType = data;
    },
    addToCart(state, payload) {
      let index = null;

      let goodsData = state.deliveries[payload.guid];
      let limit = instance.$reachDishLimitPrice(goodsData);
      if (limit) {
        payload.price = goodsData.commodityPricing.price;
        payload.is_threshold = 1;
      }

      if (payload.index != undefined) {
        index = payload.index;
        let lastIndex = state.carts.findLastIndex(item => {
          return item.guid === payload.guid;
        });
        if (lastIndex !== index) index = lastIndex;
      } else {
        index = state.carts.findLastIndex(item => {
          return item.guid === payload.guid;
        });
      }

      if (limit && !state.carts[index].is_threshold) {
        payload = {
          ...state.carts[index],
          price: goodsData.commodityPricing.price,
          is_threshold: 1,
          num: 1
        };
        index = -1;
      }

      console.log(1234567890);
      if (index !== -1 && !checkSameGoods(payload, state.carts[index])) {
        index = -1;
      }

      if (index === -1) {
        state.carts.push(payload);
      } else {
        if (payload.resetNum) {
          state.carts[index].num = payload.num;
        } else {
          state.carts[index].num += payload.num;
        }
      }
    },
    minusFromCart(state, payload) {
      let index = null;

      if (payload.index != undefined) {
        index = payload.index;

        let is_threshold = false;
        let existIndex = state.carts.findLastIndex(item => {
          if (item.guid === payload.guid) {
            is_threshold = item.is_threshold;
          }
          return item.guid === payload.guid;
        });
        if (existIndex !== index && existIndex > index && is_threshold) {
          index = existIndex;
        }
      } else {
        index = state.carts.findLastIndex(item => {
          return item.guid === payload.guid;
        });
      }

      if (index === -1) {
        return;
      }

      const cart = state.carts[index];
      const num = cart.num - payload.num;

      if (num <= 0) {
        state.carts.splice(index, 1);
        return;
      }

      state.carts[index].num = num;
    },
    removeFromCart(state, payload) {
      state.carts.splice(payload.index, 1);
    },
    clearCart(state) {
      state.carts = [];
    },
    setStorePayment(state, payment) {
      state.storePayment = payment;
    },
    setAddressList(state, data) {
      state.addressList = data;
    },
    setStoreInfo(state, storeInfo) {
      state.storeInfo = storeInfo;
      let list =
        JSON.parse((storeInfo.storeConf && storeInfo.storeConf.lang) || "[]") ||
        [];
      state.languageList = list.filter(item => item.enable);
      if (
        state.languageList &&
        state.languageList[0] &&
        !localStorage.getItem("language")
      ) {
        let lan = state.languageListVal[state.languageList[0].val - 1];
        if (window.globalI18n) window.globalI18n.locale = lan;
        state.language = lan;
      }
      let logoItem = (storeInfo.images || []).find(
        item => item.imageTypeStr === "Logo"
      );
      if (logoItem) {
        changeFavicon(logoItem.url);
      }
      state.languageListAll = list;
    },
    setRecommendDeliveries(state, deliveries) {
      state.recommendDeliveries = deliveries;
    },
    closeCookie(state) {
      state.showCookie = false;
    },
    setLanguage(state, language) {
      state.language = language;
    },
    setDiscounts(state, discounts) {
      state.discounts = discounts;
    },
    setActiveCategoryPhone(state, activeCategoryPhone) {
      state.activeCategoryPhone = activeCategoryPhone;
    },
    resetCart(state, payload) {
      state.carts = payload;
    },
    setDeliveryType(state, deliveryType) {
      state.deliveryType = deliveryType;
    }
  },

  actions: {
    async getDeliveryCategory({ state, commit }) {
      try {
        const {
          data: { isError, data }
        } = await Delivery.getDeliveryCategory({ storeGuid: state.storeId });

        if (isError) {
          return;
        }

        const categoryKeys = [];
        const categories = {};

        data.forEach(item => {
          const { guid } = item;
          categoryKeys.push(guid);
          categories[guid] = item;
        });

        commit("setCategories", categories);
        commit("setCategoryKeys", categoryKeys);
      } catch (e) {
        console.log(e);
      }
    },

    /**
     * 获取菜品分类列表 - 新
     * @param {*} param0
     */
    async getDeliveries({ state, commit, dispatch }) {
      //在有菜品数据的情况下不再次发起请求
      if (state.deliveryMenu && state.deliveryMenu.length) return;

      let {
        data: { isError, data: cateGoryList }
      } = await Delivery.getDeliveryCategory2({ storeGuid: state.storeId });
      if (isError) return;

      const categoryKeys = [];
      const categories = {};
      const deliveryMenu = [];

      cateGoryList.forEach(item => {
        const { guid, ...category } = item;
        categoryKeys.push(guid);
        const menu = {
          guid,
          ...category
        };
        categories[guid] = {
          ...menu
        };
        deliveryMenu.push(menu);
        dispatch("getDeliveriesList", {
          categoryGuid: item.guid
        });
      });

      commit("setCategoryKeys", categoryKeys);
      commit("setCategories", categories);
      commit("setDeliveryMenu", deliveryMenu);
    },

    async getDeliveriesList({ state, commit }, payload) {
      try {
        const { categoryGuid } = payload;
        const {
          data: { isError, data }
        } = await Delivery.getDeliveries({
          storeGuid: state.storeId,
          categoryGuid
        });

        if (isError) {
          return;
        }

        let { categories, deliveryMenu, deliveries } = state;

        categories[categoryGuid].commodites = JSON.parse(JSON.stringify(data));
        deliveryMenu.find(
          item => item.guid === categoryGuid
        ).commodites = data.map(delivery => {
          if (delivery.images && delivery.images.length > 0) {
            delivery.cover = delivery.images[0];
          } else {
            delivery.cover = {};
          }

          deliveries[delivery.guid] = delivery;
          return delivery;
        });

        commit("setCategories", categories);
        commit("setDeliveries", deliveries);
        commit("setDeliveryMenu", deliveryMenu);
      } catch (e) {
        console.log(e);
      }
    },
    async getDeliveryDetail({ commit }, payload) {
      try {
        const {
          data: { isError, data }
        } = await Delivery.getDeliveryDetail(payload);

        if (isError) {
          return;
        }

        data.cover =
          data.images && data.images.length > 0 ? data.images[0] : {};
        commit("setDelivery", data);
        commit("setCurrentDelivery", payload.guid);
      } catch (e) {
        console.log(e);
      }
    },
    async getStorePayment({ state, commit }) {
      try {
        const {
          data: { isError, data }
        } = await Store.getStorePayment({ storeGuid: state.storeId });

        if (isError) {
          return;
        }

        commit("setStorePayment", data);
      } catch (e) {
        console.log(e);
      }
    },
    // async loadAddress({ commit }) {
    //   try {
    //     const {
    //       data: { isError, data }
    //     } = await Address.loadAddress();
    //
    //     if (isError) {
    //       return;
    //     }
    //
    //     commit("setAddressList", data);
    //     console.log('获取地址接口',data)
    //   } catch (e) {
    //     console.log(e);
    //   }
    // },
    async getThemeColor({ state, commit }) {
      insertThemeStyle();
      const {
        data: { isError, data }
      } = await Store.getThemeColor({
        guid: state.storeId
      });
      console.log(data);

      if (!isError) {
        insertThemeStyle(data || "#f8c12e");
      }

      function insertThemeStyle(color) {
        let css = `html{ --themeColor: ${color || "#f8c12e"};}`,
          head = document.getElementsByTagName("head")[0],
          style = document.createElement("style");
        style.rel = "stylesheet";
        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }
        head.appendChild(style);
      }
    },
    async getStoreInfo({ state, commit, dispatch }) {
      try {
        if (!state.storeId) {
          location.hash = "/";
          return;
        }
        const {
          data: { isError, data }
        } = await Store.getStoreInfo({
          guid: state.storeId,
          zipCode: localStorage.getItem("zipCode")
        });
        if (isError) {
          // this.$router.push({ name: "index" });
          window.location.href = window.location.host + "/#/" + "index";
          return;
        }

        const info = {
          ...data
        };

        window.timeZone = info.storeConf && info.storeConf.timeZone;

        if (info.images && info.images.length > 0) {
          info.images.forEach(item => {
            if (item.imageType === "Logo") {
              info.logo = {
                ...item
              };
            } else if (item.imageTypeStr == "Background") {
              info.background = {
                ...item
              };
            }
          });
        }

        // 0关闭 不接收外卖单 1 正常接单且外送 2 接单但不外送
        // info.takeawayStatus = 1

        commit("setStoreInfo", info);

        dispatch("getThemeColor");

        if (
          state.deliveryType == null ||
          (state.deliveryType == 0 && info.takeawayStatus == 2)
        ) {
          commit("setDeliveryType", info.takeawayStatus == 2 ? 1 : 0);
        }
      } catch (e) {
        console.error(e);
      }
    },
    async getStoreMainBusiness() {
      try {
        const {
          data: { isError, data }
        } = await Store.getStoreMainBusiness();

        if (isError) {
          return;
        }

        console.log(data);
      } catch (e) {
        console.error(e);
      }
    },
    async getRecommendDelivery({ state, commit }, payload) {
      try {
        const {
          data: { isError, data }
        } = await Delivery.getRecommendDelivery({
          ...payload,
          storeGuid: state.storeId
        });

        if (isError) {
          return;
        }

        const deliveries = data.map(delivery => {
          if (!delivery) delivery = {};
          delivery.cover =
            delivery.images && delivery.images.length > 0
              ? delivery.images[0]
              : {};
          return delivery;
        });

        commit("setRecommendDeliveries", deliveries);
      } catch (e) {
        console.error(e);
      }
    },
    async getAllCoupons({ state, commit }) {
      try {
        const {
          data: { isError, data }
        } = await Store.getAllCoupons({ storeGuid: state.storeId });

        if (isError) {
          return;
        }

        commit("setDiscounts", data);
      } catch (e) {
        console.log(e);
      }
    }
  }
});
function conpareArray(arr1 = [], arr2 = []) {
  let result = true;
  result = arr1.length === arr2.length;
  arr1.map(item => {
    if (!arr2.includes(item)) {
      result = false;
    }
  });
  return result;
}
//检查传入的两个商品是否相同 主要用于添加菜品
function checkSameGoods(newGoods, oldGoods) {
  let same = true;
  if (!conpareArray(newGoods.garnish || [], oldGoods.garnish || []))
    same = false;
  // if (newGoods.attributes && newGoods.attributes.length) {
  //     if (!conpareArray(newGoods.attributes || [], oldGoods.attributes || [])) {
  //         same = false;
  //     }
  // }
  if (newGoods.price !== oldGoods.price) same = false;
  return same;
}
